import { jsx as i } from "react/jsx-runtime";
import { u as t } from "./index-6a632112.mjs";
import { s as r } from "./themes-5f0b3c3d.mjs";
import "react";
const n = "spinner-test-id", c = t.div`
  --circle-diameter: ${(e) => e.$size === "large" ? r["16x"] : e.$size === "medium" ? r["8x"] : r["6x"]};
  --line-weight: ${r["1x"]};
  position: relative;
  width: var(--circle-diameter);
  height: var(--circle-diameter);

  &::before {
    position: absolute;
    content: '';
    top: 0;
    left: 50%;
    width: var(--circle-diameter);
    height: var(--circle-diameter);
    bottom: 0;
    right: 0;
    box-sizing: border-box;
    margin-left: calc(var(--circle-diameter) / -2);
    border-radius: var(--circle-diameter);
    border: var(--line-weight) solid
      ${(e) => e.theme.components.spinner.circleBorderColor};
  }
`, d = t.div`
  position: relative;

  &::before {
    position: absolute;
    content: '';
    width: var(--circle-diameter);
    height: var(--circle-diameter);
    left: 50%;
    box-sizing: border-box;
    margin-left: calc((var(--circle-diameter)) / -2);
    border-radius: var(--circle-diameter);
    border: var(--line-weight) solid transparent;
    border-top: var(--line-weight) solid
      ${(e) => e.theme.components.spinner.circleProgressBarBorderColor};
    transform: rotate(0deg);
    animation-name: circularindetermiate;
    animation-iteration-count: infinite;
    animation-duration: 1s;
    animation-timing-function: linear;
  }

  @keyframes circularindetermiate {
    100% {
      transform: rotate(360deg);
    }
  }
`, g = ({ size: e, dataTestId: o, ...a }) => /* @__PURE__ */ i(
  c,
  {
    $size: e,
    "data-testid": o || n,
    ...a,
    children: /* @__PURE__ */ i(d, {})
  }
);
export {
  g as Spinner
};
